import userRequest from '@/utils/request';
// import { getToken } from '@/utils/token.js'
// const userInfo = JSON.parse(getToken('userInfo'))

const reFix = 'useradmin';

// 查看用户总佣金
export function getUserBonusApi(params) {
  return userRequest({
    url: reFix + '/Money/bonus',
    params: { ...params },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 查看用户待发放佣金
export function lookAwaitBonusApi(params) {
  return userRequest({
    url: reFix + '/Money/waitBonus',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 查看用户已发放佣金
export function lookYetBonusApi(params) {
  return userRequest({
    url: reFix + '/Money/issuedBonus',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 查看三级分销率
export function lookMultiApi(params) {
  return userRequest({
    url: reFix + '/MultiLevel',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 编辑三级分销率
export function editMultiApi(data) {
  return userRequest({
    url: reFix + '/MultiLevel',
    method: 'POST',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
